var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 3.5H4.5C3.94687 3.5 3.5 3.94687 3.5 4.5V27.5C3.5 28.0531 3.94687 28.5 4.5 28.5H27.5C28.0531 28.5 28.5 28.0531 28.5 27.5V4.5C28.5 3.94687 28.0531 3.5 27.5 3.5ZM26.25 18H16.5V14H26.25V18ZM26.25 26.25H5.75V5.75H26.25V12H15.5C14.9469 12 14.5 12.4469 14.5 13V19C14.5 19.5531 14.9469 20 15.5 20H26.25V26.25ZM18.125 16C18.125 16.3315 18.2567 16.6495 18.4911 16.8839C18.7255 17.1183 19.0435 17.25 19.375 17.25C19.7065 17.25 20.0245 17.1183 20.2589 16.8839C20.4933 16.6495 20.625 16.3315 20.625 16C20.625 15.6685 20.4933 15.3505 20.2589 15.1161C20.0245 14.8817 19.7065 14.75 19.375 14.75C19.0435 14.75 18.7255 14.8817 18.4911 15.1161C18.2567 15.3505 18.125 15.6685 18.125 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.cab14228df1ecc0489089494b23d8bda.svg";
export { ForwardRef as ReactComponent };